<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onClose()"
  [nzWidth]="'800px'"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <ejs-pdfviewer
        id="pdfViewer"
        [enableNavigationToolbar]="false"
        [serviceUrl]='service' [documentPath]='fileUrl'
        locale="es-MX"
        [toolbarSettings]="toolbarSettings"
        style="height:640px;display:block; width:100%;">
      </ejs-pdfviewer>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="d-flex justify-content-end">
      <a [href]="fileUrl" [download]="fileUrl">
        <button nz-button nzType="default" class="btn-default">
          <i nz-icon nzType="cloud-download" nzTheme="outline"></i>
          Descargar archivo
        </button>
      </a>
    </div>
  </ng-template>
</nz-modal>
